import type { Update } from "@/services/api/types";

export const UPDATE_CATEGORY_LABELS: Record<
  Update["category"],
  string
> = {
  release_notes: "Release notes",
  general_notification: "General notification",
  urgent_notification: "Urgent notification",
  roadmap_update: "Roadmap update",
};